import React from "react";
import { IText } from "../types";

//TODO: this should be removed; redundant with the store!
export const TextsContext = React.createContext(
  {} as { [data: string]: IText }
);
